import {AdvancedMarker, useMap} from "@vis.gl/react-google-maps";
import {useState} from "react";
import {SchoolMarker} from "@/pages/workspaces/sales/SchoolMarker";
import {ClusterMarker} from "@/pages/workspaces/sales/ClusterMarker";
import {useSales} from "@/pages/workspaces/sales/SalesContext";

function ClusterOrSiteMarker({site, hoveredMarkerId}) {
  if (site.cluster)
    return (<ClusterMarker cluster={site} hoveredMarkerId={hoveredMarkerId}/>)
  else return (<SchoolMarker site={site} hoveredMarkerId={hoveredMarkerId}/>)
}

export const ClusteredMarker = (props) => {
  const {site} = props;
  const {dispatch} = useSales();
  const [hoveredMarkerId, setHoveredMarkerId] = useState(null);
  const map = useMap();

  const handleClick = () => {
    dispatch({type: 'SET_CLICKED_ITEM', payload: site});
    if (map) {
      const zoom = map.getZoom()
      map.panTo({lat: site.lat, lng: site.lng});
      if (zoom < 9) map.setZoom(9);
      else if (zoom < 13) map.setZoom(zoom + 1);
    }
  };

  const lat = site.latitude || site.lat;
  const lng = site.longitude || site.lng;

  if (
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    lat < -90 || lat > 90 ||
    lng < -180 || lng > 180
  ) {
    // bad site
    return;
  }
  if (lat === 0 && lng === 0) return false;

  return (<AdvancedMarker
    position={{lat, lng}}
    onClick={handleClick}
    onMouseEnter={() => setHoveredMarkerId(site.id)}
    onMouseLeave={() => setHoveredMarkerId(null)}
    zIndex={hoveredMarkerId === site.id ? 10000 : -10}
  >
    <ClusterOrSiteMarker site={site} hoveredMarkerId={hoveredMarkerId}/>
  </AdvancedMarker>);
};
